import type { Variants, Transition } from 'motion/react';

export const jiggle: Variants = {
  idle: { rotate: 0 },
  jiggle: {
    rotate: [-1.5, 1.5, -1.5],
    transition: {
      repeat: Infinity,
      duration: 0.3,
      ease: 'easeInOut',
    },
  },
};

export const poofExit = {
  scale: 0,
  opacity: 0,
  filter: 'blur(8px)',
  transition: { duration: 0.3 },
};

export const entrySpring: Transition = {
  type: 'spring',
  stiffness: 400,
  damping: 25,
};

export const containerStagger: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.04 },
  },
};

export const itemEntry: Variants = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: entrySpring,
  },
};

/** iOS 26.2 "Bloom" — staggered pour from origin */
export const bloomContainerVariants: Variants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.055,
      delayChildren: 0.08,
    },
  },
};

/** iOS 26.2 item entrance — scale + bounce from origin */
export const bloomItemVariants: Variants = {
  hidden: {
    scale: 0,
    y: 12,
  },
  visible: {
    scale: 1,
    y: 0,
    transition: {
      type: 'spring',
      stiffness: 520,
      damping: 22,
      mass: 0.6,
    },
  },
};
